module.exports = __webpack_public_path__ + "img/donante-extermimex.920ccc95.jpeg";